import React from "react";
import iconNameMap from "@Pages/Search/components/SearchListItem/components/FeatureTags/iconNameMap";
import TickMark from "@Icons/TickMark";
import ErrorBoundary from "@Components/ErrorBoundary";

const getIconName = (amenityName = "", height = "", width = "") => {
  const iconMap = iconNameMap();
  const keywords = Object.keys(iconMap);
  const nameLower = amenityName?.toLowerCase();
  const splittedName = nameLower.split(" ");
  let matchedKeyword = keywords.find((keyword) => splittedName.indexOf(keyword) > -1);
  if (!matchedKeyword) {
    matchedKeyword = keywords.find((keyword) => nameLower.includes(keyword));
  }

  if (matchedKeyword) {
    const Icon = iconMap[matchedKeyword as keyof typeof iconMap];
    const iconWithProps =
      Icon && typeof Icon !== "string"
        ? React.cloneElement(Icon as React.ReactElement, {
            ...(height ? { height } : null),
            ...(width ? { width } : null),
          })
        : Icon;

    return (
      <ErrorBoundary noErrorLog addFallbackIcons>
        {height || width ? (
          <div
            style={{
              ...(height ? { height } : { height: "16px" }),
              ...(width ? { width } : { width: "16px" }),
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {iconWithProps}
          </div>
        ) : (
          iconWithProps
        )}
      </ErrorBoundary>
    );
  }
  return (
    <div
      style={{
        ...(height ? { height } : { height: "16px" }),
        ...(width ? { width } : { width: "16px" }),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <TickMark />
    </div>
  );
};

export default getIconName;
